module.exports = __webpack_public_path__ + "fonts/iconfont.c36b7604.woff2";